<div class="grid-container">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"
         [isPanelOpened]="isPanelOpened"
         [accordionHeading]="tablesTranslations.i18nPriceCategory"
         [actionButtons]="actionButtons"
         [actionButtonIsDisabled]="!(selectedLottery.isDraftMode)"
         [emptyStateIcon]="'#esf-icon-dollar-check'"
         [emptyStateText]="tablesTranslations.i18nNoPriceCategories"
         [emptyStateButtonText]="loading ? null : tablesTranslations.i18nRequestPricesFromTixx"
         (rowButtonClickEvent)="actionButtonClicked($event)"
         (actionButtonClickEvent)="fetchPriceCategories()"
         (rowClickEvent)="selectedLottery.isDraftMode ? editPriceCategory($event) : null"
         (panelTriggerClickEvent)="isPanelOpenedChange.emit(!isPanelOpened);"
         [data]="priceCategoriesList"
         [keys]="keys"
         [columns]="columns">
      <app-spinner bottom [(show)]="loading" style="display: flex;justify-content: center;"></app-spinner>
    </div>
  </div>
</div>
